import propTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import {getMenus} from '../actions/menus';
import getPage from '../actions/pages';
import getArray from '../utils/misc';
import {Container, Hero, Layout} from '../components';

const Index = ({mainMenu, page}) => {
	return (
		<Layout mainMenu={mainMenu}>
			{page.featured_media && <Hero src={page.featured_media.source_url} caption={page.acf.hero_text && page.acf.hero_text} height='75vh' ratio='56.25%'/>}
			<Container>
				{page && (
					<section>
						<div dangerouslySetInnerHTML={{__html: page.content.rendered}}/>
					</section>
				)}
			</Container>
			<style jsx>
				{`
					section {
						padding: 40px 0 40px 0;
					}
				`}
			</style>
		</Layout>
	);
};

Index.propTypes = {
	mainMenu: propTypes.array,
	page: propTypes.object
};

Index.getInitialProps = async ({isServer, res, store}) => {
	const fns = [store.dispatch(getPage('home'))];

	if (isServer) {
		fns.push(
			store.dispatch(getMenus())
		);
	}

	const [page] = await Promise.all(fns);
	const notFound = !page.value;

	if (notFound && res) {
		res.statusCode = 404;
	}

	return {notFound};
};

export default connect(state => ({
	mainMenu: getArray(Object.values(state.menus.data).find(x => x.slug === 'main'), 'items'),
	page: Object.values(state.pages.data).find(x => x.slug === 'home')
}))(Index);



// WEBPACK FOOTER //
// pages/index.js